angular.module('aprima-legacy-common').factory('LocalStorageRepository',
    ['storage', '_', 'WebCommonStorageRepository',
        function (storage, _, WebCommonStorageRepository) {
            'use strict';

            return {

                clearAll: function () {
                    WebCommonStorageRepository.clearAll();
                },

                getIsActiveDirectoryUser: function() {
                    return WebCommonStorageRepository.getIsActiveDirectoryUser();
                },
                
                setIsActiveDirectoryUser: function(value) {
                    WebCommonStorageRepository.setIsActiveDirectoryUser(value);
                },

                getClientID: function () {
                    return WebCommonStorageRepository.getClientId();
                },

                setClientID: function (value) {
                    WebCommonStorageRepository.setClientId(value);
                },

                getNotificationTimeout: function () {
                    return storage.get('notificationTimeout');
                },

                setNotificationTimeout: function (value) {
                    storage.set('notificationTimeout', value);
                },

                setIdentityHint: function (value) {
                    storage.set('identityHint', value);
                },
                
                getIdentityHint: function () {
                    return storage.get('identityHint');
                },

                getClientURL: function () {
                    return WebCommonStorageRepository.getClientUrl();
                },

                setClientURL: function (value) {
                    WebCommonStorageRepository.setClientUrl(value);
                },

                getGatewayUrl: function () {
                    return WebCommonStorageRepository.getGatewayUrl();
                },

                setGatewayUrl: function (value) {
                    WebCommonStorageRepository.setGatewayUrl(value);
                },

                setJsonWebToken: function (jwt) {
                    WebCommonStorageRepository.setJsonWebToken(jwt);
                },
                getJsonWebToken: function () {
                    return WebCommonStorageRepository.getJsonWebToken();
                },

                removeJsonWebToken: function () {
                    WebCommonStorageRepository.removeJsonWebToken();
                },

                setUserName: function (username) {
                    WebCommonStorageRepository.setUserName(username);
                },
                getUserName: function () {
                    return WebCommonStorageRepository.getUserName();
                },

                setBirthDate: function (birthDate) {
                    storage.set('birthDate', birthDate);
                },

                getBirthDate: function () {
                    return storage.get('birthDate');
                },

                setAccessCode: function (statementId) {
                    storage.set('accessCode', statementId);
                },

                getAccessCode: function () {
                    return storage.get('accessCode');
                },

                setUserFullName: function (name) {
                    WebCommonStorageRepository.setUserFullName(name);
                },

                getUserFullName: function () {
                    return WebCommonStorageRepository.getUserFullName();
                },

                removeUserName: function () {
                    storage.remove('userName');
                },

                setUserID: function (userid) {
                    WebCommonStorageRepository.setUserId(userid);
                },

                getUserID: function () {
                    return WebCommonStorageRepository.getUserId();
                },

                getIsPatient: function () {
                    return storage.get('isPatient');
                },

                setIsPatient: function (isPatient) {
                    storage.set('isPatient', isPatient);
                },

                getSupportedFeatures: function () {
                    return storage.get('apiSupportedFeatures');
                },
                removeUserID: function () {
                    WebCommonStorageRepository.removeUserId();
                },

                setLang: function (lang) {
                    WebCommonStorageRepository.setLang(lang);
                },

                getLang: function () {
                    return WebCommonStorageRepository.getLang();
                },

                setDefaultSuperbillSubmissionMethod: function (methodId) {
                    WebCommonStorageRepository.setDefaultSuperbillSubmissionMethod(methodId);
                },

                getDefaultSuperbillSubmissionMethod: function() {
                    return WebCommonStorageRepository.getDefaultSuperbillSubmissionMethod();
                },

                setKey: function (key, value, keyType) {
                    storage.set(key, value);

                    if(keyType){
                        var activeKeys = storage.get(keyType + 'keys');
                        var keyDictionary;

                        if(activeKeys){
                            keyDictionary = activeKeys.split(',');
                        }
                        else{
                            keyDictionary = [];
                        }

                        if(!_.includes(keyDictionary, key)){
                            keyDictionary.push(key);
                            storage.set(keyType + 'keys', keyDictionary.join(','));
                        }
                    }
                },

                getKey: function (key, keyType) {
                    var k = storage.get(key);

                    // This can be removed after 1 release with it in there.  It just needs to be there to build up the initial list.
                    if(keyType){
                        var activeKeys = storage.get(keyType + 'keys');
                        var keyDictionary;

                        if(activeKeys){
                            keyDictionary = activeKeys.split(',');
                        }
                        else{
                            keyDictionary = [];
                        }

                        if(!_.includes(keyDictionary, key)){
                            keyDictionary.push(key);
                            storage.set(keyType + 'keys', keyDictionary.join(','));
                        }
                    }

                    return k;
                },

                removeKey: function (key) {
                    storage.remove(key);
                },
                setPatientDashboardWidgets: function (widget) {
                    WebCommonStorageRepository.setPatientDashboardWidgets(widget);
                },

                getPatientDashboardWidgets: function () {
                    return WebCommonStorageRepository.getPatientDashboardWidgets();
                },
                setPatientDashboardConfigurations: function (newList, type) {
                    WebCommonStorageRepository.setPatientDashboardConfigurations(newList, type);
                },

                removePatientDashboardWidgets: function () {
                    WebCommonStorageRepository.removePatientDashboardWidgets();
                },

                getPatientDashboardConfigurations: function (type) {
                    return WebCommonStorageRepository.getPatientDashboardConfigurations(type);
                },

                removePatientDashboardConfigurations: function (type) {
                    WebCommonStorageRepository.removePatientDashboardConfigurations(type);
                },

                getDashboardTileSettings: function () {
                    return WebCommonStorageRepository.getDashboardTileSettings();
                },
                setDashboardTileSettings: function (settings) {
                    WebCommonStorageRepository.setDashboardTileSettings(settings);
                },
                setDefaultDashboardTileSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultDashboardTileSettings(settings);
                },

                getAppointmentsListSettings: function () {
                    return WebCommonStorageRepository.getAppointmentsListSettings();
                },
                setAppointmentsListSettings: function (settings) {
                    WebCommonStorageRepository.setAppointmentsListSettings(settings);
                },
                setDefaultAppointmentsListSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultAppointmentsListSettings(settings);
                },

                getMessagesListSettings: function () {
                    return WebCommonStorageRepository.getMessagesListSettings();
                },
                setMessagesListSettings: function (settings) {
                    WebCommonStorageRepository.setMessagesListSettings(settings);
                },
                setDefaultMessagesListSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultMessagesListSettings(settings);
                },

                getAppointmentsBadgeSettings: function () {
                    return WebCommonStorageRepository.getAppointmentsBadgeSettings();
                },
                setAppointmentsBadgeSettings: function (settings) {
                    WebCommonStorageRepository.setAppointmentsBadgeSettings(settings);
                },
                setDefaultAppointmentsBadgeSettings: function (settings) {
                    WebCommonStorageRepository.setDefaultAppointmentsBadgeSettings(settings);
                },

                getDefaultServiceSiteId: function() {
                    return WebCommonStorageRepository.getDefaultServiceSiteId();
                },

                setDefaultServiceSiteId: function(serviceSiteId) {
                    WebCommonStorageRepository.setDefaultServiceSiteId(serviceSiteId);
                },

                getDeviceId: function () {
                    return WebCommonStorageRepository.getDeviceId();
                },

                setDeviceId: function (deviceId) {
                    WebCommonStorageRepository.setDeviceId(deviceId);
                },

                getPhoneMessageGeneralNoteTypeId: function () {
                    return WebCommonStorageRepository.getPhoneMessageGeneralNoteTypeId();
                },
                setPhoneMessageGeneralNoteTypeId: function (id) {
                    WebCommonStorageRepository.setPhoneMessageGeneralNoteTypeId(id);
                },

                getTaskMessageGeneralNoteTypeId: function () {
                    return WebCommonStorageRepository.getTaskMessageGeneralNoteTypeId();
                },
                setTaskMessageGeneralNoteTypeId: function (id) {
                    WebCommonStorageRepository.setTaskMessageGeneralNoteTypeId(id);
                },

                getPharmacyGeneralNoteTypeId: function () {
                    return WebCommonStorageRepository.getPharmacyGeneralNoteTypeId();
                },
                setPharmacyGeneralNoteTypeId: function (id) {
                    WebCommonStorageRepository.setPharmacyGeneralNoteTypeId(id);
                },

                getPortalMessageGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getPortalMessageGeneralNoteTypeId();
                },
                setPortalMessageGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setPortalMessageGeneralNoteTypeId(id);
                },

                getRxRefillMessageGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getRxRefillMessageGeneralNoteTypeId();
                },
                setRxRefillMessageGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setRxRefillMessageGeneralNoteTypeId(id);
                },

                getPharmacyRefillMessageGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getPharmacyRefillMessageGeneralNoteTypeId();
                },
                setPharmacyRefillMessageGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setPharmacyRefillMessageGeneralNoteTypeId(id);
                },

                getPatientVitalsDefaultSettingId: function () {
                    return WebCommonStorageRepository.getPatientVitalsDefaultSettingId();
                },
                setPatientVitalsDefaultSettingId: function (id) {
                    WebCommonStorageRepository.setPatientVitalsDefaultSettingId(id);
                },

                getMedicationOverrideGeneralNoteTypeId : function () {
                    return WebCommonStorageRepository.getMedicationOverrideGeneralNoteTypeId();
                },
                setMedicationOverrideGeneralNoteTypeId : function (id) {
                    WebCommonStorageRepository.setMedicationOverrideGeneralNoteTypeId(id);
                },

                getCurrentUserLicenses: function getCurrentUserLicenses() {
                    return WebCommonStorageRepository.getCurrentUserLicenses();
                },
                setCurrentUserLicenses: function setCurrentUserLicenses(licenses) {
                    WebCommonStorageRepository.setCurrentUserLicenses(licenses);
                },

                getIsERxEnabled: function () {
                    return WebCommonStorageRepository.getIsERxEnabled();
                },
                setIsERxEnabled: function (enabled) {
                    WebCommonStorageRepository.setIsERxEnabled(enabled);
                },

                getAllowImperialUnits: function () {
                    return WebCommonStorageRepository.getAllowImperialUnits();
                },
                setAllowImperialUnits: function (allowed) {
                    WebCommonStorageRepository.setAllowImperialUnits(allowed);
                },

                getApplicationVersion: function(){
                    return WebCommonStorageRepository.getApplicationVersion();
                },
                setApplicationVersion: function(version){
                    WebCommonStorageRepository.setApplicationVersion(version);
                },
                getUserPermissions: function(){
                    return WebCommonStorageRepository.getUserPermissions();
                },
                setUserPermissions: function(permissions){
                    WebCommonStorageRepository.setUserPermissions(permissions);
                },
                getAskedUserForTouchID: function() {
                    return storage.get('askedUserForTouchID');
                },
                setAskedUserForTouchID: function(prompt) {
                    storage.set('askedUserForTouchID', prompt);
                },
                getUserEnabledTouchID: function() {
                    return storage.get('userEnabledTouchID');
                },
                setUserEnabledTouchID: function(enabled) {
                    storage.set('userEnabledTouchID', enabled);
                },
                getOncePerLoginChartConsent: function() {
                    return storage.get('OncePerLoginChartConsent');
                },
                setOncePerLoginChartConsent: function(enabled) {
                    storage.set('OncePerLoginChartConsent', enabled);
                },

                clearKeysOfType: function(keyType){
                    WebCommonStorageRepository.clearKeysOfType(keyType);
                },

                clearSessionStorage: function(){
                    clearKeysOfType('list');
                    clearKeysOfType('metadata');
                },

                clearOldVersionCache: function(){
                    WebCommonStorageRepository.clearOldVersionCache();
                },

                setIsCacheUser: function(value){
                    storage.set('settings.iscacheuser', value);
                }
            };
        }]);
